import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../features/apiServices/apiClient";
import "./css/GestUsersPage.css";
import safeJSON from "../components/safeJSON";


const GestUsersPage = () => {
  const token = localStorage.getItem("accessToken");
  const tenant = safeJSON("tenant");
  const user = safeJSON("user");
  const activeRestaurant = safeJSON("activeRestaurant");

  const navigate = useNavigate();

  const [usuarios, setUsuarios] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    role: "staff", // padrão atendente
    password: ""
  });

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const canManage = user?.role === "owner";

  // =======================
  // CARREGAR USUÁRIOS
  // =======================
  const loadUsers = async () => {
    try {
      if (!canManage) return;

      const response = await api.get("/auth/users", {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant-slug": tenant.slug,
        },
      });

      setUsuarios(response.data || []);
    } catch (err) {
      console.error("Erro ao carregar usuários:", err);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("accessToken")) return;

    loadUsers();
  }, []);

  // =======================
  // HANDLERS
  // =======================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const resetForm = () => {
    setEditingId(null);
    setFormData({
      name: "",
      email: "",
      role: "staff",
      password: "",
    });
  };

  // =======================
  // CRIAR USUÁRIO
  // =======================
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await api.post(
        "/auth/register",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "x-tenant-slug": tenant.slug,
          },
        }
      );

      resetForm();
      loadUsers();
    } catch (err) {
      console.error("Erro ao cadastrar usuário:", err);
      alert("Erro ao cadastrar.");
    }
  };

  // =======================
  // EDITAR USUÁRIO
  // =======================
  const startEdit = (u) => {
    //let roleMapped = u.role;
    //if (roleMapped === "Atendente") roleMapped = "staff";
    //if (roleMapped === "Gerente") roleMapped = "owner";

    setEditingId(u.id);
    setFormData({
      name: u.name,
      email: u.email,
      role: u.role,
      password: "",
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      await api.put(
        `/auth/users/${editingId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "x-tenant-slug": tenant.slug,
          },
        }
      );

      resetForm();
      loadUsers();
    } catch (err) {
      console.error("Erro ao editar usuário:", err);
      alert("Erro ao editar.");
    }
  };

  // =======================
  // EXCLUIR
  // =======================
  const askDelete = (id) => {
    setDeleteId(id);
    setConfirmDelete(true);
  };

  const confirmDeletion = async () => {
    try {
      await api.delete(`/auth/users/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant-slug": tenant.slug,
        },
      });

      setConfirmDelete(false);
      setDeleteId(null);
      loadUsers();
    } catch (err) {
      console.error("Erro ao excluir:", err);
      alert("Erro ao excluir.");
    }
  };

  return (
    <div className="usuarios-container">

      {/* =======================
          HEADER
      ======================== */}
      <header className="user-header">
        <img
          src={"/assets/logo-mesaclick.png"}
          alt="MesaClick"
          className="user-header-logo"
          onClick={() => navigate("/home")}
        />
        <h1 className="header-title">Gestão de Usuários</h1>

        {activeRestaurant && (
          <span className="mc-rest-badge" style={{ marginLeft: "auto" }}>
            <span className="mc-rest-badge-dot" />
            {activeRestaurant.nome}
          </span>
        )}
      </header>



      {/* =======================
          TELA DIVIDIDA
      ======================== */}
      <div className="split-container">

        {/* =======================
            FORMULÁRIO
        ======================== */}
        <div className="left-pane">
          <h2 className="section-title">
            {editingId ? "Editar Usuário" : "Cadastrar Usuário"}
          </h2>

          <div className="form-section">
            <div className="form-group">
              <label className="label">Nome</label>
              <input
                className="input"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Nome completo"
                autoComplete="off"
              />
            </div>

            <div className="form-group">
              <label className="label">Email</label>
              <input
                className="input"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="email@exemplo.com"
                autoComplete="off"
              />
            </div>

            <div className="form-group">
              <label className="label">Função</label>
              <select
                className="input"
                name="role"
                value={formData.role}
                onChange={handleChange}
              >
                <option value="owner">Gerente</option>
                <option value="staff">Atendente</option>
              </select>
            </div>

            <div className="form-group">
              <label className="label">Senha {editingId ? "(opcional)" : ""}</label>
              <input
                className="input"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="********"
                autoComplete="new-password"
              />
            </div>

            <div className="form-buttons">
              <button
                className="btn-save"
                onClick={editingId ? handleUpdate : handleSubmit}
              >
                {editingId ? "Salvar Alterações" : "Cadastrar"}
              </button>

              {editingId && (
                <button className="btn-cancel" onClick={resetForm}>
                  Cancelar
                </button>
              )}
            </div>
          </div>
        </div>

        {/* =======================
            LISTA DE USUÁRIOS
        ======================== */}
        <div className="right-pane">
          <h2 className="section-title">Usuários cadastrados</h2>

          <div className="rest-list">
            {usuarios.length === 0 && (
              <p className="empty-text">Nenhum usuário cadastrado.</p>
            )}

            {usuarios.map((u) => (
              <div key={u.id} className="rest-card">
                <div className="rest-name">{u.name}</div>
                <div className="rest-info">
                  {u.email} • {u.role === "owner" ? "Gerente" : "Atendente"}
                </div>

                {canManage && (
                  <div className="rest-btns">
                    <button className="btn-edit" onClick={() => startEdit(u)}>
                      Editar
                    </button>

                    <button
                      className="btn-delete"
                      onClick={() => askDelete(u.id)}
                    >
                      Excluir
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* =======================
          MODAL DELETE
      ======================== */}
      {confirmDelete && (
        <div className="mc-modal-overlay">
          <div className="mc-modal">
            <img src="/assets/logo-mesaclick.png" className="mc-modal-logo" />
            <p className="mc-modal-text">Deseja excluir este usuário?</p>

            <div className="mc-modal-actions">
              <button className="mc-btn-cancel" onClick={() => setConfirmDelete(false)}>
                Cancelar
              </button>
              <button className="mc-btn-confirm" onClick={confirmDeletion}>
                Excluir
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default GestUsersPage;
